import React from 'react'
import PropTypes from 'prop-types'
import { Slider } from 'components'
import { OFFSET_RADIUS } from 'constants/for-you'

const LocationRangeSlider = ({ value, icon, className, onChange }) => (
  <Slider
    className={className}
    icon={icon}
    minValue={OFFSET_RADIUS.min}
    maxValue={OFFSET_RADIUS.max}
    defaultValue={OFFSET_RADIUS.defaultValue}
    value={value}
    label={`${value}mi${value === OFFSET_RADIUS.max ? '+' : ''}`}
    onChange={value => onChange(value)}
  />
)

LocationRangeSlider.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.object,
  value: PropTypes.number,
  onChange: PropTypes.func,
}

export default LocationRangeSlider
